import React from 'react';

import FooterNeswletter from '../../components/Footer/FooterNewsletter';
import DisclaimerNotice from '../../components/Footer/DisclaimerNotice';
import UpperFooter from '../../components/Footer/Upperfooter';
import LowerFooter from '../../components/Footer/Lowerfooter';
import { useIsMobile } from '../../hooks/useIsMobile';
import MetodosPagoge from '../../components/Footer/Metodospago';

export function FooterPortal(props){
    const {
        visible = null
    } = props;

    const { isMobile } = useIsMobile();
    
    return(
        <>
            {isMobile
                ?
                    isMobile === 'desktop'
                        ?
                            <footer className="nhfooter no-printme ">
                                <FooterNeswletter />
                                <UpperFooter />
                                <MetodosPagoge/>
                                <DisclaimerNotice />
                                <LowerFooter />
                            </footer>
                        :  
                            visible
                                ?
                                    <footer className="nhfooter no-printme ">
                                        <FooterNeswletter />
                                        <UpperFooter />
                                        <MetodosPagoge/>
                                        <DisclaimerNotice />
                                        <LowerFooter />
                                    </footer>
                            
                                :
                                    null
                : null
            }
        </>
        
    )
}